import { app } from '../../../../../../app';
import { Controller } from './edit.controller';

app.component('editProfileBasic', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./edit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/basic/edit/edit.component.js